import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer" id="footer">
            <div className="socials">
                <a href="https://github.com/lsiver" target="_blank" rel="noopener noreferrer">
                    <div className="socials__github">
                        <img src="github2.png" alt="GitHub link"/>
                    </div>
                </a>
                <a href="mailto:siverlingluke@gmail.com" target="_blank" rel="noopener noreferrer">
                    <div className="socials__email">
                        <img src="email.png" alt="Email link"/>
                    </div>
                </a>
                <a href="https://www.linkedin.com/in/ldsiverling/" target="_blank" rel="noopener noreferrer">
                    <div className="socials__linkedin">
                        <img src="linkedin.png" alt="linkedin"/>
                    </div>
                </a>
            </div>
        </footer>
    );
};

export default Footer;